import IndustryList from "./List";
import IndustryEdit from "./Edit";
export default [
    { exact: true, path: "/industries", component: IndustryList },
    { exact: true, path: "/industry/c", component: IndustryEdit },
    { path: "/industry/c/:name", component: IndustryEdit },
    { path: "/industry/e/:iid", component: IndustryEdit }
];
